export type RpGalleryAmplitudeLocation = "rp_property_page" | "rp_investment_page";

/**
 * Amplitude `location` for the gallery events (`open_gallery`, `view_photo`) fired from the RP detail pages.
 * The tracking helpers still default to the KM value, so RP entry points that were verified with analytics
 * pass this location explicitly.
 */
export const getRpGalleryAmplitudeLocation = (propertyId?: number): RpGalleryAmplitudeLocation =>
    propertyId != null ? "rp_property_page" : "rp_investment_page";
export type RpGalleryAmplitudeLocation = "rp_property_page" | "rp_investment_page";

/**
 * Amplitude `location` for the gallery events (`open_gallery`, `view_photo`) fired from the RP detail pages.
 * The tracking helpers still default to the KM value, so RP entry points that were verified with analytics
 * pass this location explicitly.
 */
export const getRpGalleryAmplitudeLocation = (propertyId?: number): RpGalleryAmplitudeLocation =>
    propertyId != null ? "rp_property_page" : "rp_investment_page";
